(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.multiselectcolumnbuilder = skyward.multiselectcolumnbuilder || {};

        skyward.multiselectcolumnbuilder.launch = function (args)
        {
            ///<param name="args">{ fieldsToDisplayInfo : string, fieldPath : string, module : string, object : string, callback : function }</param>

            var showPopup = function (jsonResult)
            {
                ///<param name="jsonResult">{ html: html }</param>
                var popup;
                var promptFieldsToDisplay;

                var onSave = function ()
                {
                    var selectedItemStrings = [];
                    selectedItems.children().not(".selectedRowTemplate").each(function ()
                    {
                        var row = $(this);
                        selectedItemStrings.push(ConvertSelectedRowToString(row));
                    });

                    args.callback(selectedItemStrings.join());
                    popup.close();
                };

                var buttons = [{ text: "Save", click: onSave, icon: "Save", additionalClasses: "promptFieldsToDisplaySaveButton" }, { text: "Cancel", click: "close", icon: "Cancel" }];
                popup = skyward.modalLayer.showDialog("Fields To Display", jsonResult.html, buttons, { width: "953px", closeOnClick: false });

                var promptFieldsToDisplay = popup.content;
                var selectedItems = promptFieldsToDisplay.find(".selectedItemsTable tbody");
                var editorButtons = {
                    moveUp: promptFieldsToDisplay.find(".moveItem.up"),
                    moveDown: promptFieldsToDisplay.find(".moveItem.down"),
                    add: promptFieldsToDisplay.find(".addItem"),
                    remove: promptFieldsToDisplay.find(".removeItem")
                };
                var displayRadioButtonGroup = $("#selectedItemsDisplayRadio_RadioButtonGroup");

                displayRadioButtonGroup.on("change", displayChange);

                promptFieldsToDisplay.on("treeBrowseSave", addSelectedItem);
                promptFieldsToDisplay.on("treeBrowseRowChange", clickAvailableItem);
                selectedItems.children().on("click", clickSelectedItem);

                editorButtons.add.on("click", addSelectedItem);
                editorButtons.remove.on("click", removeSelectedItem);
                editorButtons.moveUp.on("click", moveSelectedItemUp);
                editorButtons.moveDown.on("click", moveSelectedItemDown);

                function displayChange()
                {
                    var displayValue = skyward.radioButtonGroup.getValue(displayRadioButtonGroup);
                    var fieldWidth = displayRadioButtonGroup.parents(".selectedItem ").find(".selectedItemsFieldWidth");

                    if (displayValue === "false")
                    {
                        fieldWidth.val("");
                        fieldWidth.prop("disabled", true);
                    }
                    else
                    {
                        fieldWidth.prop("disabled", false);
                        fieldWidth.val(fieldWidth.data().defaultwidth);
                    }
                }

                function clickAvailableItem()
                {
                    clearSelectedFromSelectedItems();

                    toggleButtons();
                }

                function clickSelectedItem()
                {
                    clearSelectedFromSelectedItems();
                    clearSelectedFromAvailableItems();

                    var selectedRow = $(this);
                    selectedRow.addClass("ui-selected");

                    toggleButtons();
                }

                function clearSelectedFromSelectedItems()
                {
                    selectedItems.find(".ui-selected").removeClass("ui-selected");
                }

                function clearSelectedFromAvailableItems()
                {
                    skyward.treebrowse.getTreeBrowseData(promptFieldsToDisplay).selectRecord(null);
                }

                function toggleButtons()
                {
                    var availableItemData = skyward.treebrowse.getSelectedFieldData(promptFieldsToDisplay);
                    var selectedItemsSelected = selectedItems.find(".ui-selected");
                    if (availableItemData)
                    {
                        setActiveButtons({
                            add: !availableItemData.isRelationship && !checkIfSelectedItemAlreadyAdded(selectedItems, availableItemData.absoluteFieldPath),
                            remove: false,
                            moveUp: false,
                            moveDown: false
                        });
                    }
                    else if (selectedItemsSelected.length > 0)
                    {
                        if (selectedItemsSelected.hasClass("distinctFieldRow"))
                        {
                            setActiveButtons({ add: false, remove: false, moveUp: false, moveDown: false });
                        }
                        else
                        {
                            setActiveButtons({
                                add: false,
                                remove: true,
                                moveUp: selectedItemsSelected.prevAll().not(".distinctFieldRow, .selectedRowTemplate").length > 0,
                                moveDown: selectedItemsSelected.next().length > 0
                            });
                        }
                    }
                    else
                    {
                        setActiveButtons({ add: false, remove: false, moveUp: false, moveDown: false });
                    }
                }

                function setActiveButtons(args)
                {
                    ///<param name="args">{add: bool, moveUp: bool, moveDown: bool, remove: bool}</param>

                    editorButtons.remove.toggleClass("ui-disabled", !args.remove);
                    editorButtons.add.toggleClass("ui-disabled", !args.add);
                    editorButtons.moveUp.toggleClass("ui-disabled", !args.moveUp);
                    editorButtons.moveDown.toggleClass("ui-disabled", !args.moveDown);
                }
                function moveSelectedItemUp()
                {
                    if (editorButtons.moveUp.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);

                    if (selectedRow && selectedRow.length > 0)
                    {
                        var previousRow = selectedRow.prev(".selectedItem");

                        if (selectedRow.prev(".selectedItem").not(".selectedRowTemplate, .distinctFieldRow").length > 0)
                        {
                            selectedRow.detach().insertBefore(previousRow);
                            toggleButtons();
                        }
                    }
                }

                function moveSelectedItemDown()
                {
                    if (editorButtons.moveDown.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);
                    if (selectedRow && selectedRow.length > 0)
                    {
                        var nextRow = selectedRow.next(".selectedItem");
                        if (nextRow.length > 0)
                        {
                            selectedRow.detach().insertAfter(nextRow);
                            toggleButtons();
                        }
                    }
                }

                function removeSelectedItem()
                {
                    if (editorButtons.remove.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);
                    if (selectedRow && selectedRow.length > 0)
                    {
                        selectedRow.remove();

                        if (selectedItems.children().not(".selectedRowTemplate").length === 1)
                        {
                            skyward.radioButtonGroup.setValue(displayRadioButtonGroup, "true");
                            skyward.radioButtonGroup.disable(displayRadioButtonGroup);
                        }
                        toggleButtons();
                    }
                }

                function addSelectedItem()
                {
                    if (editorButtons.add.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRowData = skyward.treebrowse.getSelectedFieldData(promptFieldsToDisplay);
                    if (selectedRowData)
                    {
                        if (checkIfSelectedItemAlreadyAdded(selectedItems, selectedRowData.absoluteFieldPath))
                        {
                            return;
                        }

                        if (selectedItems.children().not(".selectedRowTemplate").length === 1)
                        {
                            skyward.radioButtonGroup.enable(displayRadioButtonGroup);
                        }

                        selectedItems.append(createSelectedItemRow(selectedRowData));
                        toggleButtons();
                    }
                }

                function checkIfSelectedItemAlreadyAdded(selectedItems, selectedFieldName)
                {
                    return selectedItems.find(".fieldNameColumn[data-fieldname=\"" + selectedFieldName + "\"]").not(".selectedRowTemplate").length > 0;
                }

                function createSelectedItemRow(availableItemData)
                {
                    var fieldPath = availableItemData.absoluteFieldPath;
                    var displayText = availableItemData.displayPathText;
                    var width = availableItemData.fieldWidth;

                    var newSelectedItem = selectedItems.find(".selectedRowTemplate").clone(true);
                    newSelectedItem.removeClass("selectedRowTemplate");

                    var fieldNameColumn = newSelectedItem.find(".fieldNameColumn");
                    fieldNameColumn.data().fieldname = fieldPath;
                    fieldNameColumn.attr("data-fieldname", fieldPath);

                    newSelectedItem.find(".selectedItemsFieldName .buttonText").text(displayText);

                    newSelectedItem.find(".selectedItemsFieldWidth").val(width);

                    newSelectedItem.show();
                    return newSelectedItem;
                }

                function getSelectedRow(editor)
                {
                    var selectedRow = editor.find(".selected").parent();
                    if (selectedRow.length > 0)
                    {
                        return selectedRow;
                    }
                    else
                    {
                        selectedRow = editor.find(".ui-selected");
                        if (selectedRow.length > 0)
                        {
                            return selectedRow;
                        }
                    }
                    return null;
                }

                function ConvertSelectedRowToString(row)
                {
                    var fieldNameColumn = row.find(".fieldNameColumn");
                    var fieldNameColumnData = fieldNameColumn.data();
                    var widthInput = row.find(".selectedItemsFieldWidth");
                    var widthInputValue = widthInput.val();
                    var displayInput = row.find("#selectedItemsDisplayRadio_RadioButtonGroup");

                    var rowString = fieldNameColumnData.fieldname;

                    if (displayInput.length > 0)
                    {
                        var displayValue = skyward.radioButtonGroup.getValue(displayInput);
                        if (displayValue === "false" || displayValue === "False")
                        {
                            rowString += " hide";
                            return rowString;
                        }
                    }

                    if (widthInputValue.length > 0)
                    {
                        rowString += " " + widthInputValue;
                    }

                    return rowString;
                }
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetMultiSelectColumnBuilder",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        fieldsToDisplayInfo: args.fieldsToDisplayInfo,
                        distinctFieldPath: args.fieldPath,
                        treeBrowseModule: args.module,
                        treeBrowseObject: args.object
                    }
                }).done(showPopup);
        };

    }(window.skyward = window.skyward || {}, window.jQuery));